import Head from 'next/head';

export const SearchJsonLd = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: 'https://RTPCheck.com/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://RTPCheck.com/?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }),
    }}
  />
);

interface BreadcrumbItem {
  name: string;
  href: string;
}

interface BreadcrumbPropsItem {
  breadcrumbs: BreadcrumbItem[];
}

const BreadcrumbJsonLd = ({ breadcrumbs }: BreadcrumbPropsItem) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.name,
      item: breadcrumb.href,
    })),
  };

  return (
    <Head>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Head>
  );
};

export default BreadcrumbJsonLd;
